module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--logout"
  }, [_c('div', {
    staticClass: "group group--narrower group--last"
  }, [(_vm.message.title) ? _c('h1', {
    staticClass: "h1 mw600",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.message.title))]) : _vm._e(), _vm._v(" "), (_vm.message.description) ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.message.description))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a57e7a4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Logout.vue
// module id = 479
// module chunks = 0